module.exports = __webpack_public_path__ + "img/mouseMoveArrow.8f6eabef.svg";